module.exports = __webpack_public_path__ + "static/media/m_hairstyle_suave_front_shadow.c25efde0.png";